import axios from 'axios';
import store from './store';
import router from './router';
import authService from './services/auth.service'

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: true
});


// ★ 요청할 때마다 JWT 추가
api.interceptors.request.use(
    config => {
        const accessToken = store.state.auth.user?.accessToken;

        if (accessToken) {
            config.headers = config.headers || {};
            config.headers['x-access-token'] = accessToken;
        }

        return config;
    },
    error => Promise.reject(error)
);


// 응답에서 401 처리
api.interceptors.response.use(
    res => res,
    async err => {
        const originalRequest = err.config;

        const isShare =
            router.currentRoute.value.path.startsWith('/share');

        if (err.response?.status === 403) {
            if (!isShare) {
                store.dispatch('auth/logout');
                router.push('/login');
            }

            return Promise.reject(err);
        }

        if (
            err.response?.status === 401 &&
            !originalRequest._retry &&
            !originalRequest.url.includes('auth/refresh') &&
            err.response?.data?.code !== "MICROSOFT_REAUTH_REQUIRED"
        ) {
            originalRequest._retry = true;

            try {
                const refreshResponse =
                    await authService.refreshToken();

                const newAccessToken =
                    refreshResponse.data.accessToken;

                originalRequest.headers =
                    originalRequest.headers || {};

                originalRequest.headers['x-access-token'] =
                    newAccessToken;

                return await api(originalRequest);

            } catch (refreshErr) {

                if (!isShare) {
                    store.dispatch('auth/logout');
                    router.push('/login');
                }

                return Promise.reject(refreshErr);
            }
        }

        return Promise.reject(err);
    }
);

export default api;